module.exports = __webpack_public_path__ + "static/img/27f94452c9e57f208481d79cb1571c53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/true_icon.png
// module id = vpXR
// module chunks = 1